import { render, staticRenderFns } from "./favoritespin.vue?vue&type=template&id=4035caae&scoped=true"
import script from "./favoritespin.vue?vue&type=script&lang=js"
export * from "./favoritespin.vue?vue&type=script&lang=js"
import style0 from "./favoritespin.vue?vue&type=style&index=0&id=4035caae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4035caae",
  null
  
)

/* custom blocks */
import block0 from "./favoritespin.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports